import React from 'react';
import ContentBlock from '../ContentBlock';
import Button from '../Button';
import Visual from './images/ilus-contact-time.svg';
import CalendarVisual from './images/icon-services-bubble.svg';

const BookMeetingWithUs = () => (
  <ContentBlock image={Visual} imagePosition="left" id="book-meeting">
    <center>
      <img src={CalendarVisual} alt="" />
      <h2>Book a meeting with us!</h2>
      <p>
        Select from these options and we´ll route your request to the
        appropriate person.
      </p>
      <Button href="https://calendly.com/361studio/book-a-meeting">
        Make an Appointment
      </Button>
    </center>
  </ContentBlock>
);

BookMeetingWithUs.propTypes = {};

BookMeetingWithUs.defaultProps = {};

export default BookMeetingWithUs;
